module.exports = __webpack_public_path__ + "img/hic-digestive-diseases-male.c3df50ad.png";